<template>
    <div class="accordion__item">
      <div class="accordion__title">
        <div
          class="accordion__trigger"
          :class="{'accordion__trigger_active': visible}"
          @click="open">
          <icon-base class="icon-wrap" red>
            <icon-plus-minus :minus="visible" />
          </icon-base>
          <slot name="title"/>
        </div>
        <!-- <slot name="title"/> -->
      </div>
      <transition
        name="accordion"
        @enter="start"
        @after-enter="end"
        @before-leave="start"
        @after-leave="end">
        <div class="accordion__wrapper" v-show="visible">
          <div class="accordion__content"><slot name="content"/></div>
        </div>
      </transition>
    </div>
</template>

<script>
import { IconPlusMinus } from 'Icons';

export default {
  components: {
    IconPlusMinus,
  },
  props: {
    title: String,
    openFirstGroup: Boolean,
  },
  inject: ['Accordion'],
  data() {
    return {
      index: null,
    };
  },
  computed: {
    visible() {
      return this.index === this.Accordion.active;
    },
  },
  methods: {
    open() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }
    },
    start(e) {
      e.style.height = `${e.scrollHeight}px`;
    },
    end(e) {
      e.style.height = '';
      this.$emit('onClickAccordionItem');
    },
  },
  created() {
    this.Accordion.count += 1;
    this.index = this.Accordion.count;
    if (this.openFirstGroup) {
      this.Accordion.active = 1;
    }
  },
};
</script>

<style lang="scss" scoped>

.accordion-enter-active, .accordion-leave-active {
  will-change: height, opacity;
  transition: height $transition ease, opacity $transition ease;
  overflow: hidden;
}

.accordion-enter, .accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}

.accordion__item {
  background: $white-color2;
  margin: 10px 0;
  border-radius: 5px;
  user-select: none;
}
.accordion__trigger {
  display: inline-block;
  width: 100%;
  padding: 16px 0 16px $alerts-list-padding-left;
  cursor: pointer;
  .icon-wrap {
    position: relative;
    top: -2px;
  }
}
.accordion__title {
  display: flex;
  align-items: center;
}
.accordion__content {
  position: relative;
}
</style>




// WEBPACK FOOTER //
// src/components/uikit/Accordion/VueAccordionItem.vue